import React from 'react';
import Icon from './Icon';

export default Icon(
  <g>
    <g>
      <path
        d="M10.4,9.5c0-1,0-2.1,0-3.1c0-0.8,0.4-1.4,1.1-1.6c1.1-0.4,2.2,0.4,2.2,1.6c0,2.2,0,4.3,0,6.5
                c0,0.8-0.5,1.4-1.1,1.6c-0.7,0.2-1.4,0-1.8-0.6c-0.3-0.3-0.3-0.7-0.3-1.1C10.4,11.6,10.4,10.6,10.4,9.5z"
      />
      <path
        d="M12,19.3c-0.9,0-1.6-0.8-1.6-1.6c0-0.9,0.8-1.6,1.7-1.6c0.9,0,1.6,0.8,1.6,1.6C13.6,18.6,12.9,19.4,12,19.3z"
      />
    </g>
  </g>, '0 0 24 24', 'ErroreIcon',
);
